<div class="card">
    <div class="card-header">
        <button class="btn btn-light btn-xs" (click)="expanded = !expanded">
            @if (expanded) {
            <span class="dripicons-chevron-up"></span>
            }
            @if (!expanded) {
            <span class="dripicons-chevron-down"></span>
            }
        </button>
        {{words[language][ 'floorPlans' ] }}
        <div class="float-right font-weight-bold">Total Floor Plan Cost: {{floorPlanTotalSum | currency}} </div>
    </div>
    @if (expanded) {
        <div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        @if (showCreateForm) {
                        <form [formGroup]="information">
                            <div class="row">
                                <div class="form-group col-md-3 col-sm-12">
                                    <contact-advanced-search type="floorPlanVendor" (setContactId)="setContactIdEvent($event)" [contactIdSaved]="information.get('vendorId').value" [isDisabled]="modify"></contact-advanced-search>
                                </div>
                                <div class="form-group col-md-2 col-sm-12">
                                    <label class="text-nowrap" for="accountNumber">{{words[language][ 'accountNumber' ]}}</label>
                                    <count-input id="accountNumber" [control]="information.get('accountNumber')"></count-input>
                                </div>
                                <div class="form-group col-md-2 col-sm-12">
                                    <label class="text-nowrap" for="initialAmount">{{words[language][ 'Initial Amount' ]}}</label>
                                    <currency-input id="initialAmount" [control]="information.get('initialAmount')"></currency-input>
                                </div>
                                <div class="form-group col-md-2 col-sm-12">
                                    <label class="text-nowrap" for="dateOnFloorPlan"> {{words[language][ 'Date on Floor Plan' ] }}</label>
                                    <input class="form-control form-control-sm text-dark" type="date" id="dateOnFloorPlan" name="dateOnFloorPlan" formControlName="dateOnFloorPlan" max="3000-01-01">
                                </div>
                                <div class="form-group col-md-2 col-sm-12">
                                    <label class="text-nowrap" for="initialFeeAmount">Initial Fee Amount</label>
                                    <currency-input id="initialFeeAmount" [control]="information.get('initialFeeAmount')"></currency-input>
                                </div>
                                <div class="form-group col-md-1 col-sm-12">
                                    <label class="text-nowrap" for="apr">APR</label>
                                    <percent-input id="apr" [control]="information.get('apr')"></percent-input>
                                </div>
                                <div class="form-group col-md-2 col-sm-12">
                                    <label class="text-nowrap" for="daysPerYear">Days per Year</label>
                                    <count-input id="daysPerYear" [control]="information.get('daysPerYear')"></count-input>
                                </div>
                                <div class="form-group col-md-2 col-sm-12">
                                    <label class="text-nowrap" for="daysAllowed">{{words[language][ '# of Days' ] }}</label>
                                    <count-input id="daysAllowed" [control]="information.get('daysAllowed')"></count-input>
                                </div>
                                <div class="form-group col-md-2 col-sm-12">
                                    <label class="text-nowrap" for="reductionAmount">Reduction Amount (Default)</label>
                                    <currency-input id="reductionAmountreductionAmount" [control]="information.get('reductionAmount')"></currency-input>
                                </div>
                                <div class="form-group col-md-2 col-sm-12">
                                    <label class="text-nowrap" for="reductionFrequency">Payment Frequency</label>
                                    <select class="form-control form-control-sm" formControlName="reductionFrequency" name="reductionFrequency" id="reductionFrequency">
                                        @for (frequency of paymentFrequency; track frequency) {
                                            <option [value]="frequency.toLowerCase()">{{frequency}}</option>
                                        }
                                    </select>
                                </div>
                                <div class="form-group col-md-2 col-sm-12">
                                    <label class="text-nowrap" for="feeAmount">Recurring Fee Amount (Default)</label>
                                    <currency-input id="feeAmount" [control]="information.get('feeAmount')"></currency-input>
                                </div>
                            </div>
                        </form>
                        }
                        @if (inventoryId !== 0 && showCreateForm) {
                            <div>
                                @if (this.information.get('vendorId').value) {
                                    <button class="btn btn-light btn-sm float-right" id="btn-reset" (click)="resetInformation(true)">Clear</button>
                                }
                                @if (!showCreateForm) {
                                    <button class="btn btn-success btn-sm float-right" (click)="resetInformation(true)" id="btn-save-floorPlans" [disabled]="information.invalid || loading">Create Floor Plan</button>
                                }
                                @if (showCreateForm) {
                                    <button class="btn btn-success btn-sm float-right" (click)="showCreateForm = !showCreateForm; save()" id="btn-save-floorPlans" [disabled]="information.invalid || loading">Save Floor Plan</button>
                                }
                            </div>
                        }
                    </div>
                </div>
                @if (floorPlanDisplayed) {
                    <section>
                        <div class="row">
                            <div class="col-md-6 col-sm-12 row">
                                <label class="text-nowrap" for="floorPlanId" class="col-3 col-form-label">Floor Plans</label>
                                <div class="col-9">
                                    <select class="form-control form-control-sm" #fp (change)="selectFloorPlan(fp.value)" id="floorPlanId">
                                        @for (fp of floorPlans; track fp; let i = $index) {
                                            <option [value]="i">{{fp.contact.name}} - {{fp.status}}</option>
                                        }
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                @if (floorPlanDisplayed) {
                                    <button class="btn btn-sm btn-info" data-toggle="modal" id="btn-modal-defaults" data-target="#floorPlanDefaultsModal">View Floor Plan Defaults</button>
                                }
                                @if (floorPlanReductionLines.length == 1) {
                                    <button class="btn btn-sm btn-danger" data-toggle="modal" id="btn-modal-delete-floor-plan" data-target="#floorPlanDeleteModal">Delete Floor Plan</button>
                                }
                            </div>
                        </div>
                        <div class="row">
                            @if (floorPlanDisplayed ? floorPlanDisplayed.status === 'Active' : false) {
                                <div class="col-md-3 col-sm-12">
                                    <h5>Record Floor Plan Reduction</h5>
                                    <section>
                                        <form [formGroup]="informationReduce">
                                            <div class="row">
                                                <div class="form-group col-12">
                                                    <label class="text-nowrap" for="datePaid">Date Paid</label>
                                                    <input class="form-control form-control-sm text-dark" type="date" id="datePaid" name="datePaid" formControlName="datePaid">
                                                    @if (informationReduce.controls['datePaid'].errors) {
                                                        <span class="text-danger">{{informationReduce.controls['datePaid'].errors.datePaid}}</span>
                                                    }
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="form-group col-md-6 col-sm-12">
                                                    <label class="text-nowrap" for="reductionAmount">Reduction Amount</label>
                                                    <currency-input id="reductionAmount" [control]="informationReduce.get('reductionAmount')"></currency-input>
                                                    @if (informationReduce.controls['reductionAmount'].errors) {
                                                        <span class="text-danger">{{informationReduce.controls['reductionAmount'].errors.reductionAmount}}</span>
                                                    }
                                                </div>
                                                <div class="form-group col-md-6 col-sm-12">
                                                    <label class="text-nowrap" for="feeAmount">Fee Amount</label>
                                                    <currency-input id="feeAmount" [control]="informationReduce.get('feeAmount')"></currency-input>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="form-group col-md-6 col-sm-12">
                                                    <label class="text-nowrap" for="financeCharges">Finance Charges</label>
                                                    <currency-input id="financeCharges" [control]="informationReduce.get('financeCharges')"></currency-input>
                                                </div>
                                                <div class="form-group col-md-6 col-sm-12">
                                                    <label class="text-nowrap" for="apr">APR</label>
                                                    <percent-input id="apr" [control]="informationReduce.get('apr')"></percent-input>
                                                </div>
                                            </div>
                                            <div>
                                                <button class="btn btn-success btn-sm" (click)="modify = false; saveReduction()" id="btn-add-reduction" [disabled]="informationReduce.invalid || loading">Add Reduction</button>
                                                @if (selectedId !== null) {
                                                    <button class="btn-warning btn-sm btn text-dark" (click)="resetInformationReduce()">Clear</button>
                                                }
                                            </div>
                                        </form>
                                    </section>
                                </div>
                            }
                            <div class="col-md-6 col-sm-12">
                                <h5>Floor Plan Reduction Lines</h5>
                                <div class="tableFixHead table-responsive">
                                    <table class="border table table-hover text-dark overflow-none text-nowrap">
                                        <thead>
                                            <tr>
                                                <th>Reduction</th>
                                                <th>Date Paid</th>
                                                <th>Principal</th>
                                                <th>APR</th>
                                                <th>Fin. Charges</th>
                                                <th>Fees</th>
                                                <th>Balance</th>
                                                @if (floorPlanDisplayed ? floorPlanDisplayed.status === 'Active' : false) {
                                                    <th>Actions</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (floorPlanReductionLine of floorPlanReductionLines; track floorPlanReductionLine; let i = $index) {
                                                <tr [ngClass]="{'bg-success': selectedId === floorPlanReductionLine.id}">
                                                    <td>{{floorPlanReductionLine.reductionAmount| currency}}</td>
                                                    <td>{{floorPlanReductionLine.datePaid | date:'MM/dd/yyyy'}}</td>
                                                    <td>{{floorPlanReductionLine.currentPrincipal| currency}}</td>
                                                    <td [ngClass]="{'text-warning':floorPlanReductionLine.alteredAPR}">{{floorPlanReductionLine.reductionAPR}}</td>
                                                    <td [ngClass]="{'text-warning':floorPlanReductionLine.alteredFinCharge}">{{floorPlanReductionLine.financeCharges | currency}}</td>
                                                    <td>{{floorPlanReductionLine.feeAmount | currency}}</td>
                                                    <td>{{floorPlanReductionLine.currentBalance| currency}}</td>
                                                    @if (floorPlanDisplayed ? floorPlanDisplayed.status === 'Active' && selectedId == null : false ) {
                                                        <td>
                                                            <button class="btn-sm btn text-dark p-0" (click)="modify = true; setInformationReduce(floorPlanReductionLine, true)"><span class="uil-pen"></span></button>
                                                            @if (i !== 0) {
                                                                <button class="btn-sm btn text-danger p-0" (click)="setDeleteId(floorPlanReductionLine.id)" data-toggle="modal" id="btn-modal-deleteReduction" data-target="#deleteReductionModal"><span class="uil-trash-alt text-danger"></span></button>
                                                            }
                                                        </td>
                                                    }
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-12">
                                <h5>Current Floor Plan Totals</h5>
                                @if (floorPlanTotals) {
                                <table class="table table-sm table-borderless overflow-none text-dark">
                                    <tbody>
                                        <tr>
                                            <td class="text-nowrap">{{words[language][ 'Principle Balance' ] }} </td>
                                            <td class="text-right">{{floorPlanTotals.currentPrincipal | currency}}</td>
                                        </tr>
                                        <tr>
                                            <td>Floor Plan Cost</td>
                                            <td class="text-right">
                                                {{floorPlanTotals.financeChargesTotal*1 +
                                                floorPlanTotals.initialFeeAmountTotal*1 +
                                                floorPlanTotals.feeAmountTotal*1 | currency}}</td>
                                        </tr>
                                        <tr>
                                            <table class="table ml-3 m-0">
                                                <tbody>
                                                    <tr>
                                                        <td>Finance Charges</td>
                                                        <td class="text-right">
                                                            {{floorPlanTotals.financeChargesTotal | currency}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Initial Fee</td>
                                                        <td class="text-right">{{floorPlanTotals.initialFeeAmountTotal |
                                                            currency}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Additional Fees</td>
                                                        <td class="text-right">{{floorPlanTotals.feeAmountTotal | currency}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </tr>
                                        <tr class="border-top">
                                            <td>Total Payoff Balance </td>
                                            <td class="text-right">{{floorPlanTotals.currentBalance | currency}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                }
                                <div class="col-md-12 col-sm-12">
                                    @if (floorPlanDisplayed ? floorPlanDisplayed.status === 'Active' && selectedId == null: false) {
                                    <button class="btn btn-success btn-sm" id="btn-reset" (click)="payOff(floorPlanDisplayed ? floorPlanDisplayed.id : null, floorPlanTotals.currentBalance)">Payoff Floor Plan</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                }
            </div>
        </div>
    }
</div>

<!-- ! delete modal -->
<div class="modal fade" id="deleteReductionModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger h1"></span>
                <h4 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h4>
                <span class="text-muted my-3 text-center">Are you sure you want to delete this reduction?</span>

                <button class="btn btn-danger mt-2" (click)="deleteReduction()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}
                </button>
                <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="close-delete-modal-reduction">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- ! delete modal -->
<div class="modal fade" id="floorPlanDeleteModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger h1"></span>
                <h4 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h4>
                <span class="text-muted my-3 text-center">Are you sure you want to delete this floor plan?</span>

                <button class="btn btn-danger mt-2" (click)="deleteFloorPlan()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}
                </button>
                <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="close-delete-modal-floor-plan">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- ! defaults modal -->
<div class="modal fade" id="floorPlanDefaultsModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">Floor Plan Defaults
                <span class="float-right clickable" data-dismiss="modal">x</span>
            </div>
            <div class="modal-body">
                <div class="col-md-12">
                    @if (floorPlanDisplayed) {
                    <table class="table table-hover table-borderless text-dark">
                        <tbody>
                            <tr>
                                <td>Company Name</td>
                                <td>{{floorPlanDisplayed.contact.name}}</td>
                            </tr>
                            <tr>
                                <td>Account Number</td>
                                <td>{{floorPlanDisplayed.accountNumber}}</td>
                            </tr>
                            <tr>
                                <td>Days per Year</td>
                                <td>{{floorPlanDisplayed.daysPerYear}}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>{{floorPlanDisplayed.status}}</td>
                            </tr>
                            <tr>
                                <td>Initial Amount</td>
                                <td>{{floorPlanDisplayed.initialAmount| currency}}</td>
                            </tr>
                            <tr>
                                <td>Start Date On Floor Plan</td>
                                <td>{{floorPlanDisplayed.dateOnFloorPlan | date:'MM/dd/yyyy'}}</td>
                            </tr>
                            <tr>
                                <td>Last Date On Floor Plan</td>
                                <td>{{floorPlanDisplayed.lastDateOnFloorPlan |
                                    date:'MM/dd/yyyy'}}</td>
                            </tr>
                            <tr>
                                <td>Reduction Amount (Default)</td>
                                <td>{{floorPlanDisplayed.reductionAmount| currency}}</td>
                            </tr>
                            <tr>
                                <td>Initial Fee Amount (Default)</td>
                                <td>{{floorPlanDisplayed.initialFeeAmount| currency}}</td>
                            </tr>
                            <tr>
                                <td>Recurring Fee Amount (Default)</td>
                                <td>{{floorPlanDisplayed.feeAmount |
                                    currency}}</td>
                            </tr>
                            <tr>
                                <td>Payment Frequency</td>
                                <td>{{floorPlanDisplayed.reductionFrequency }}</td>
                            </tr>
                            <tr>
                                <td>APR</td>
                                <td>{{floorPlanDisplayed.apr}}%</td>
                            </tr>
                            <tr>
                                <td>Days Allowed</td>
                                <td>{{floorPlanDisplayed.daysAllowed}}</td>
                            </tr>
                            <tr>
                                <td>Days On Floor Plan</td>
                                <td [ngClass]="{'text-danger': floorPlanDisplayed.daysOnFloorPlan < 0}">{{floorPlanDisplayed.daysOnFloorPlan}}</td>
                            </tr>
                            <tr>
                                <td>Days Remaining</td>
                                <td [ngClass]="{'text-danger': floorPlanDisplayed.daysRemaining < 0}">{{floorPlanDisplayed.daysRemaining}}</td>
                            </tr>
                            <tr>
                                <td>Days Past Limit</td>
                                <td [ngClass]="{'text-danger': floorPlanDisplayed.daysPastLimit < 0}">{{floorPlanDisplayed.daysPastLimit}}</td>
                            </tr>
                        </tbody>
                    </table>
                    }
                </div>
            </div>
            <div class="modal-footer">
                @if (floorPlanDisplayed ? floorPlanDisplayed.status === 'Active' : false) {
                    <button type="button" class="btn btn-sm btn-info" (click)="modifyDefaults()">Modify Defaults</button>
                }
                <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" id="close-modify-modal-floor-plan">Close</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
